module.exports = __webpack_public_path__ + "f0bb5ed264d1847869bf2da03a1794a9.svg";